import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

import { useStyles } from './styles.js';

const Divider = props => {
  const { classes } = props;

  return <div className={classes.divider} />;
};

Divider.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(Divider);
